import script from "./Groups.vue?vue&type=script&setup=true&lang=ts"
export * from "./Groups.vue?vue&type=script&setup=true&lang=ts"

import "./Groups.vue?vue&type=style&index=0&id=5ce66aa2&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce66aa2"]])

export default __exports__